// Angular
import { Component, Input, OnInit } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Layout
import { SubheaderService } from '../../../../../core/_base/layout';
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service';

@Component({
  selector: 'kt-subheader4',
  templateUrl: './subheader4.component.html',
  styleUrls: ['./subheader4.component.scss']
})
export class Subheader4Component implements OnInit {
  // Public properties
  @Input() fluid: boolean;
  @Input() clear: boolean;

  today: number = Date.now();
  headerTranslateKey$: BehaviorSubject<string>;
  breadcrumbs$: BehaviorSubject<Breadcrumb[]>;

  constructor(public subheaderService: SubheaderService) { }

  ngOnInit() {
    this.headerTranslateKey$ = this.subheaderService.title$;
    this.breadcrumbs$ = this.subheaderService.breadcrumbs$;
  }
}
